import { StyledTd } from "../cell/baseTd.jsx";
import { Brand, BrandChip, getBrandID } from "../../../schema/brand.js";
import { Setter } from "solid-js";
import { FilterCondition } from "../../../schema/filter.js";
import { preview } from "vite";

type RGB = `rgb(${number}, ${number}, ${number})`;
type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;
type HEX = `#${string}`;
type Color = RGB | RGBA | HEX;

interface BrandStyle {
  background: Color;
  border: Color;
  color: Color;
}

export const BrandCell = (props: {
  brand: Brand;
  setFilterCondition: Setter<FilterCondition>;
  noFilter?: boolean;
  style?: BrandStyle;
}) => {
  const noFilter = props.noFilter ?? false;

  const applyFilter = (brand: Brand) => {
    props.setFilterCondition((prev) => ({
      ...prev,
      brand: [brand],
    }));
  };
  const cell = (
    <StyledTd>
      <BrandChip
        onClick={(e) => {
          if (!noFilter) applyFilter(e.target.innerHTML as Brand);
        }}
        macaronBrand={getBrandID(props.brand)}
        macaronNoFilter={noFilter}
        // class={style(props.style || {})}
      >
        {props.brand}
      </BrandChip>
    </StyledTd>
  );
  return cell;
};
